import styled from 'styled-components';

const Section = styled.section`
  margin-top: 1.5rem;
`;

export default Section;
